module.exports = __webpack_public_path__ + "img/discovery_cn.fdfae04c.png";